import useI18n from "@/i18n/index.js";
const { t } = useI18n.global;

/* {
    ...,
    meta: {
        title: "", 名称
        x: 0, 图标的精灵图位置
        hidden: false, 是否隐藏
    }
} */

const HomeChildren = [
    {
        path: "performance",
        name: "entrance",
        component: () => import("@/views/pages/performance/entrance.vue"),
        meta: {
            title: "绩效管理",
            x: -515,
            only: true
        },
    },
    {
        path: "maintenance",
        name: "maintain",
        component: () => import("@/views/pages/maintenance/maintain.vue"),
        meta: {
            title: "数据维护",
            x: 4.5,
            only: true
        },
    },
    {
        path: "templateManager",
        name: "templateManager",
        component: () => import("@/views/pages/templateManager/templateManager.vue"),
        meta: {
            title: "模板管理",
            x: -35,
            only: true,
        },
    },
    {
        path: "account",
        name: "account",
        meta: {
            title: "账号管理",
            x: -75.5
        },
        children: [
            {
                path: "role",
                name: "role",
                component: () => import("@/views/pages/account/role.vue"),
                meta: {
                    title: "角色管理"
                }
            },
            {
                path: "user",
                name: "user",
                component: () => import("@/views/pages/account/user.vue"),
                meta: {
                    title: "用户管理"
                }
            },
        ]
    },
    {
        path: "membership",
        name: "membership",
        meta: {
            title: "会员营销",
            x: -115.5
        },
        children: [
            {
                path: "member",
                name: "member",
                component: () => import("@/views/pages/membership/member.vue"),
                meta: {
                    title: "会员维护"
                }
            },
            {
                path: "marketing",
                name: "marketing",
                component: () => import("@/views/pages/membership/marketing.vue"),
                meta: {
                    title: "营销统计"
                }
            },
        ]
    },
    {
        path: "recordFile",
        name: "recordFile",
        component: () => import("@/views/pages/patient/recordFile.vue"),
        meta: {
            title: "患者档案",
            x: -156,
            only: true
        },
    },
    {
        path: "workforce",
        name: "workforce",
        meta: {
            title: "排班管理",
            x: -195.5
        },
        children: [
            {
                path: "template",
                name: "template",
                component: () => import("@/views/pages/workforce/template.vue"),
                meta: {
                    title: "排班模板"
                }
            },
            {
                path: "mananger",
                name: "mananger",
                component: () => import("@/views/pages/workforce/mananger.vue"),
                meta: {
                    title: "排班管理"
                }
            },
        ]
    },
    {
        path: "registration",
        name: "registration",
        meta: {
            title: "门诊挂号",
            x: -235.5
        },
        children: [
            {
                path: "scene",
                name: "scene",
                component: () => import("@/views/pages/outpatientRegistration/scene.vue"),
                meta: {
                    title: "现场挂号"
                }
            },
            {
                path: "booking",
                name: "booking",
                component: () => import("@/views/pages/outpatientRegistration/booking.vue"),
                meta: {
                    title: "预约挂号"
                }
            },
            {
                path: "inquire",
                name: "inquire",
                component: () => import("@/views/pages/outpatientRegistration/inquire.vue"),
                meta: {
                    title: "挂号查询(退号)"
                }
            },
        ]
    },
    {
        path: "writeCase",
        name: "write",
        component: () => import("@/views/pages/doctorWorking/write.vue"),
        meta: {
            title: "门诊作业",
            x: -275.5,
            only: true
        },
    },
    {
        path: "outpatientCollectfee",
        name: "outpatientCollectfee",
        meta: {
            title: "门诊收费",
            x: -315
        },
        children: [
            {
                path: "collectfee",
                name: "collectfee",
                component: () => import("@/views/pages/outpatientCollectfee/collectfee.vue"),
                meta: {
                    title: "门诊收费"
                }
            },
            {
                path: "dividePrice",
                name: "dividePrice",
                component: () => import("@/views/pages/outpatientCollectfee/dividePrice.vue"),
                meta: {
                    title: "划价收费"
                }
            },
            {
                path: "search",
                name: "search",
                component: () => import("@/views/pages/outpatientCollectfee/search.vue"),
                meta: {
                    title: "收费查询(退费)"
                }
            },
            {
                path: "report",
                name: "report",
                component: () => import("@/views/pages/outpatientCollectfee/report.vue"),
                meta: {
                    title: "收款日结报表"
                }
            },
            {
                path: "invoiceUseReport",
                name: "invoiceUseReport",
                component: () => import("@/views/pages/outpatientCollectfee/invoiceUseReport.vue"),
                meta: {
                    title: "发票使用统计"
                }
            },
        ]
    },
    {
        path: "dispense",
        name: "dispense",
        component: () => import("@/views/pages/pharmacy/dispense.vue"),
        meta: {
            title: "门诊发药",
            x: -474.5,
            only: true
        },
    },
    {
        path: "execute",
        name: "execute",
        meta: {
            title: "门诊执行",
            x: -355
        },
        children: [
            {
                path: "injection",
                name: "injection",
                component: () => import("@/views/pages/execution/injection.vue"),
                meta: {
                    title: "输注执行"
                }
            },
            {
                path: "disposal",
                name: "disposal",
                component: () => import("@/views/pages/execution/disposal.vue"),
                meta: {
                    title: "治疗执行",
                    reportId: 105
                }
            }
        ]
    },
    {
        path: "inventory",
        name: "inventory",
        meta: {
            title: "库存管理",
            x: -395.5
        },
        children: [
            {
                path: "supplier",
                name: "supplier",
                component: () => import("@/views/pages/inventory/supplier.vue"),
                meta: {
                    title: "供应商维护"
                }
            },
            {
                path: "inWareHouse",
                name: "inWareHouse",
                component: () => import("@/views/pages/inventory/wareHouse/inWareHouse.vue"),
                meta: {
                    title: "入库管理"
                }
            },
            {
                path: "outWareHouse",
                name: "outWareHouse",
                component: () => import("@/views/pages/inventory/wareHouse/outWareHouse.vue"),
                meta: {
                    title: "出库管理",
                }
            },
            {
                path: "checkWareHouse",
                name: "checkWareHouse",
                component: () => import("@/views/pages/inventory/checkWareHouse/checkWareHouse.vue"),
                meta: {
                    title: "盘点作业",
                }
            },
            {
                path: "outStock",
                name: "outStock",
                component: () => import("@/views/pages/inventory/outStock/outStock.vue"),
                meta: {
                    title: "实时库存",
                }
            }
        ]
    },
    {
        path: "inspect",
        name: "inspect",
        meta: {
            title: "检验管理",
            x: -555
        },
        children: [
            {
                path: "sampling",
                name: "sampling",
                component: () => import("@/views/pages/inspect/sampling.vue"),
                meta: {
                    title: "采样组设置"
                }
            },
            {
                path: "checkDetails",
                name: "checkDetails",
                component: () => import("@/views/pages/inspect/checkDetails.vue"),
                meta: {
                    title: "检验细项维护"
                }
            },
            {
                path: "detailsRelevance",
                name: "detailsRelevance",
                component: () => import("@/views/pages/inspect/detailsRelevance.vue"),
                meta: {
                    title: "检验细项关联"
                }
            },
            {
                path: "signIn",
                name: "signIn",
                component: () => import("@/views/pages/inspect/signIn.vue"),
                meta: {
                    title: "检验签收"
                }
            },
            {
                path: "inspectReport",
                name: "inspectReport",
                component: () => import("@/views/pages/inspect/inspectReport.vue"),
                meta: {
                    title: "检验报告"
                }
            },
            {
                path: "machineList",
                name: "machineList",
                component: () => import("@/views/pages/inspect/machineList.vue"),
                meta: {
                    title: "设备清单"
                }
            }
        ]
    },
    {
        path: "executionReport",
        name: "executionReport",
        component: () => import("@/views/pages/examine/executionReport.vue"),
        meta: {
            title: "检查报告",
            x: -595.5,
            only: true
        }
    },
    {
        path: "statisticalanalysis",
        name: "statisticalanalysis",
        meta: {
            title: "运营业务",
            x: -435
        },
        children: [
            {
                path: "operationstatistical",
                name: "operationstatistical",
                component: () => import("@/views/pages/statistical/modules/operationstatistical.vue"),
                meta: {
                    title: "运营统计"
                }
            },
            {
                path: "storagestatistical",
                name: "storagestatistical",
                component: () => import("@/views/pages/statistical/modules/storagestatistical.vue"),
                meta: {
                    title: "库存统计"
                }
            }
        ]
    },
    {
        path: "medicalInsuranceRecords",
        name: "medicalInsuranceRecords",
        component: () => import("@/views/pages/Index.vue"),
        meta: {
            title: "医保备案",
            x: -475
        }
    },
    {
        path: "medicalInsuranceBusiness",
        name: "medicalInsuranceBusiness",
        meta: {
            title: "医保业务",
            x: -515.5,
        },
        children: [
            {
                path: "medicalInsurance",
                name: "medicalInsurance",
                component: () => import("@/views/pages/medicalInsurance/medicalInsurance.vue"),
                meta: {
                    title: "医保目录"
                }
            },
            {
                path: "personnelInformation",
                name: "personnelInformation",
                component: () => import("@/views/pages/medicalInsurance/personnelInformation.vue"),
                meta: {
                    title: "人员信息查询"
                }
            },
            {
                path: "settleAccount",
                name: "settleAccount",
                component: () => import("@/views/pages/medicalInsurance/settleAccount.vue"),
                meta: {
                    title: "医保结算"
                }
            },
            {
                path: "reconciliation",
                name: "reconciliation",
                component: () => import("@/views/pages/medicalInsurance/reconciliation.vue"),
                meta: {
                    title: "医保对账"
                }
            },
            {
                path: "liquidation",
                name: "liquidation",
                component: () => import("@/views/pages/medicalInsurance/liquidation.vue"),
                meta: {
                    title: "医保清算"
                }
            }
        ]
    },
    {
        path: 'inHospitalManage',
        name: 'inHospitalManage',
        meta: {
            title: '住院管理',
            x: -635.5
        },
        children: [
            {
                path: "admissionRegistration",
                name: "admissionRegistration",
                component: () => import("@/views/pages/inHospitalManage/admissionRegistration.vue"),
                meta: {
                    title: "入院登记"
                }
            },
            {
                path: "pressForPayment",
                name: "pressForPayment",
                component: () => import("@/views/pages/inHospitalManage/pressForPayment.vue"),
                meta: {
                    title: "住院催款"
                }
            },
            {
                path: "settleAccounts",
                name: "settleAccounts",
                component: () => import("@/views/pages/inHospitalManage/settleAccounts.vue"),
                meta: {
                    title: "费用结算"
                }
            },
            {
                path: "ischargeSettlement",
                name: "ischargeSettlement",
                component: () => import("@/views/pages/inHospitalManage/ischargeSettlement.vue"),
                meta: {
                    title: "出院结算"
                }
            },
            {
                path: "bcMaintenance",
                name: "bcMaintenance",
                component: () => import("@/views/pages/inHospitalManage/bcMaintenance.vue"),
                meta: {
                    title: "病床及费用维护"
                }
            }
        ]
    },
    {
        path: 'admissionOrder',
        name: 'admissionOrder',
        meta: {
            title: '住院医嘱',
            x: -675.5
        },
        children: [
            {
                path: 'inpatient',
                name: 'inpatient',
                component: () => import("@/views/pages/admissionOrder/inpatient.vue"),
                meta: {
                    title: "住院患者"
                }
            }
        ]
    },
    {
        path: 'inpatientPharmacy',
        name: 'inpatientPharmacy',
        meta: {
            title: '住院药房',
            x: -715.5
        },
        children: [
            {
                path: "medicineDispense",
                name: "medicineDispense",
                component: () => import("@/views/pages/inpatientPharmacy/medicineDispense.vue"),
                meta: {
                    title: "住院发药"
                }
            },
            {
                path: "refundableDrugsList",
                name: "refundableDrugsList",
                component: () => import("@/views/pages/inpatientPharmacy/refundableDrugsList.vue"),
                meta: {
                    title: "住院可退药清单"
                }
            },
            {
                path: "returnMedicine",
                name: "returnMedicine",
                component: () => import("@/views/pages/inpatientPharmacy/returnMedicine.vue"),
                meta: {
                    title: "退药点收"
                }
            },
            {
                path: "sendConfirm",
                name: "sendConfirm",
                component: () => import("@/views/pages/inpatientPharmacy/sendConfirm.vue"),
                meta: {
                    title: "发药确认"
                }
            },
        ]
    },
    {
        path: 'nursingSystem',
        name: 'nursingSystem',
        meta: {
            title: '护理系统',
            x: -755.5
        },
        children: [
            {
                path: "manage",
                name: "manage",
                component: () => import("@/views/pages/nursingSystem/manage.vue"),
                meta: {
                    title: "护理管理"
                }
            },
            {
                path: "dosingList",
                name: "dosingList",
                component: () => import("@/views/pages/nursingSystem/dosingList.vue"),
                meta: {
                    title: "给药清单"
                }
            },
            {
                path: "giveConfirm",
                name: "giveConfirm",
                component: () => import("@/views/pages/nursingSystem/giveConfirm.vue"),
                meta: {
                    title: "给药确认"
                }
            },
        ]
    },
]

const routes = [
    {
        path: '/',
        name: "home",
        component: () => import("@/views/Index.vue"),
        redirect: "/index",
        meta: {
            title: "首页"
        },
        children: [
            {
                path: "index",
                name: "index",
                component: () => import("@/views/pages/Index.vue"),
                meta: {
                    title: t('welcome'),
                    hidden: true
                }
            },
            ...HomeChildren
        ]
    },
    {
        path: '/',
        redirect: '/login',
        children: [
            {
                path: '/login',
                name: 'login',
                component: () => import('@/views/user/Login.vue')
            },
        ]
    },
    {
        path: '/404',
        component: () => import('@/views/exception/404.vue'),
        hidden: true
    },
    {
        path: "/:catchAll(.*)",
        redirect: "/404"
    },
]

export {
    routes,
    HomeChildren
}